import type { AdminUser } from "@milqit/shared-types";
import type { AdminLoginValues } from "@milqit/validations";

import { apiFetch } from "@/lib/api/client";

import type { AuthApi } from "./auth-store";

export const authApi: AuthApi = {
  login: (values: AdminLoginValues) =>
    apiFetch<AdminUser>("/admin/auth/login", { method: "POST", body: JSON.stringify(values) }),
  me: () => apiFetch<AdminUser>("/admin/auth/me"),
  logout: () => apiFetch<void>("/admin/auth/logout", { method: "POST" }),
};
